import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, ElementRef, Renderer2, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[nimbusNegativeButton]',
  standalone: false,
})
export class NimbusMaterialNegativeButtonDirective implements OnInit {
  private innerNegativeButton: boolean = true;

  @Input()
  public set nimbusNegativeButton(value: boolean) {
    this.innerNegativeButton = coerceBooleanProperty(value);
  }

  public get nimbusNegativeButton(): boolean {
    return this.innerNegativeButton;
  }

  public constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    if (this.innerNegativeButton) {
      this.renderer.addClass(this.elementRef.nativeElement, 'negative-button');
    }
  }
}
